module.exports = __webpack_public_path__ + "img/img_roll.8f62013a.png";